import React, {Component} from "react";
import {Link} from 'react-router-dom';
import { connect } from "react-redux";
import { updateForm } from "../../../../store/actions/FormAction";
/*
    Dashboard view that displays the Dashboard pages
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class Notice extends Component {
  constructor(props){
    super(props);
    this.dismissNotice = this.dismissNotice.bind(this);
  }

  dismissNotice(e){
    document.getElementById("dismissnotice").classList.add("hidden");
    this.props.updateForm("noticedismissed", true);
  }

  render() {
    if (this.props.status === "Pending" || this.props.status === "Fast Tracked" || this.props.status === "Recommended For Approval"){
      return (
        <div className="notice" id="dismissnotice">
          <img className="style-svg circleclose" src="/images/svg/circleclose.svg" alt="circleclose" onClick={this.dismissNotice} />
          <p>You have not verified your email! Check your inbox. Didn’t get an email? Look in your junk mail or <Link to="/dashboard/resendemail">send it again</Link>.</p>
        </div>
      );
    } else {
      return "";
    }
  }
}

const mapStateToProps = (state) => ({
    status: state.FormReducer.status,
    noticedismissed: state.FormReducer.noticedismissed
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(Notice);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/partials/Notice.js